__turbopack_context__.v({
  "badge": "ImagePreview-module-scss-module__6hzR5G__badge",
  "root": "ImagePreview-module-scss-module__6hzR5G__root",
});
